import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { KRAService }  from '../../shared/HR_ADMIN/KRA/KRAService.service';
import { KRAMasterModel } from '../../shared/HR_ADMIN/KRA/KRAMasterModel.Model';
import { KRAApplicationModel } from '../../shared/HR_ADMIN/KRA/KRAApplicationModel.Model';
import { EmployeeMasterService }  from '../../shared/HR_ADMIN/Employee/EmployeeMaster.Service';
import { EmployeeDetail } from '../../shared/HR_ADMIN/Employee/EmployeeDetail.Model';
//Begin For Notification service
import { NotificationsService} from '../../shared/notifications.service';
//End of notification service
// Begning Confirmation
import { ConfirmationService } from '@jaspero/ng2-confirmations';
import { ResolveEmit } from '../../../app/resolve-emit';
import { ConfirmSettings } from '../../../app/confirm-settings';
// end of Confirmation
import { Menu } from '../../shared/menu.model';

@Component({
  selector: 'app-manage-kraall-employee-application',
  templateUrl: './manage-kraall-employee-application.component.html',
  styleUrls: ['./manage-kraall-employee-application.component.css']
})
export class ManageKraallEmployeeApplicationComponent implements OnInit 
{
  KRAMasterModel : KRAMasterModel= new KRAMasterModel();
  KRAApplicationModel : KRAApplicationModel= new KRAApplicationModel();
  EmployeeDetails: KRAApplicationModel[] = [];
  Employees: EmployeeDetail[] = [];
  employee: any;
  KRAApplications: KRAApplicationModel[] = [];
  kraapplication: any;
  
  RefId : any;
  MasterRefId : any;
  userClaims: any;

  Result : string;
  SuccessStatus:boolean=false;
  SuccessMessage: string ="";
  public tableWidget: any;
  selectedIndex : number;
  // Begning Permission Portion    
  SelectedMenu:Menu;
  IsDataIsInViewState : boolean=false;
  CanViewState : boolean=true;
  IsApplicationView : boolean=false;
  DisableSave :boolean=false;
  Totalwts : number=0;
  TotalRating : number=null;
  FormViewState : boolean=true;
  // End of the permission portion
  EmployeeSettings = {};
  selectedItems = [];
  emp : any [] =[];

  constructor(private KRAService: KRAService,private EmployeeMasterService:EmployeeMasterService, private rout: Router, private userService: UserService,private _confirmation: ConfirmationService, private notificationsService: NotificationsService){  }

  ngOnInit() 
  {
    // Begning Permission Portion 
    this.SelectedMenu=this.userService.SelectedMenu;
    if(this.SelectedMenu !=undefined)
    {
      localStorage.setItem('selectedmenu',JSON.stringify(this.SelectedMenu));
      this.rout.navigate([this.SelectedMenu.RouteName]);
    }
    else
    {
      if(JSON.parse(localStorage.getItem('selectedmenu'))!=undefined)
      {
        this.SelectedMenu = JSON.parse(localStorage.getItem('selectedmenu'));
        this.rout.navigate([this.SelectedMenu.RouteName]);
      }
    }
    if(this.SelectedMenu.CanAdd)
    {
      this.IsDataIsInViewState=false;
    }
    else
    {
      this.IsDataIsInViewState=true;
    }
    if(this.SelectedMenu.CanView)
    {
      this.CanViewState=false;
    }
    else
    {
      this.CanViewState=true;
    }
    // End of the permission portion
    this.DisableSave=true;
    if(localStorage.getItem('SuccessfullMessage'))
    {
      this.SuccessStatus=true;
      this.SuccessMessage =localStorage.getItem('SuccessfullMessage')
      localStorage.removeItem('SuccessfullMessage');
    }
    this.Totalwts=0;
    this.GetEmployeeDetailsDDL();
    this.KRAApplicationModel.EmployeeId=0;
    this.FormViewState=false;
    this.EmployeeSettings =
    {
      singleSelection:true,
      text:'Select Employee',
      enableSearchFilter:true,
      showCheckbox:false
    }
  }

  settings: ConfirmSettings | any = 
  {
    overlay: true,
    overlayClickToClose: true,
    showCloseButton: true,
    confirmText: 'Yes',
    declineText: 'No'
  };

  ngAfterViewInit(): void 
  {

  }

  GetEmployeeDetailsDDL() 
  {
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeeMasterService.GetEmployeeDetailsForDDL( t).then(x => 
    {
      this.employee = x;
      Object.keys(this.employee).forEach( key => 
      {
        let Emptemp = new EmployeeDetail();
        Emptemp = this.employee[key];
        this.Employees.push(Emptemp);
        this.emp.push({"id":Emptemp.EmployeeId,"itemName":Emptemp.EmployeeCode + '-' +Emptemp.EmployeeName},);
      });     
    });      
  }

  GetEmployeeDetails(EmployeeId)
  {
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.KRAService.GetEmployeeDetailsBYEmployeeId( t,EmployeeId).then(x => 
    {
      this.employee = x;
      Object.keys(this.employee).forEach( key => 
      {
        this.employee[key];
        let KRAApplicationtemp = new KRAApplicationModel();
        KRAApplicationtemp = this.employee[key];
        this.KRAApplicationModel.EmployeeId=KRAApplicationtemp.EmployeeId;
        this.KRAApplicationModel.EmployeeCode=KRAApplicationtemp.EmployeeCode;
        this.KRAApplicationModel.EmployeeName=KRAApplicationtemp.EmployeeName;
        this.KRAApplicationModel.EmployeeEmailId=KRAApplicationtemp.EmployeeEmailId;
        this.KRAApplicationModel.DesignationName=KRAApplicationtemp.DesignationName;
        this.KRAApplicationModel.RHId=KRAApplicationtemp.RHId;
        this.KRAApplicationModel.RHCode=KRAApplicationtemp.RHCode;
        this.KRAApplicationModel.RHName=KRAApplicationtemp.RHName;
        this.KRAApplicationModel.RHEmailId=KRAApplicationtemp.RHEmailId;
        this.KRAApplicationModel.FHId=KRAApplicationtemp.FHId;
        this.KRAApplicationModel.FHCode=KRAApplicationtemp.FHCode;
        this.KRAApplicationModel.FHName=KRAApplicationtemp.FHName;
        this.KRAApplicationModel.FHEmailId=KRAApplicationtemp.FHEmailId;
        this.KRAApplicationModel.CompanyId=KRAApplicationtemp.CompanyId;
        this.EmployeeDetails.push(KRAApplicationtemp);
      });
      this.GetKRAApplication(this.KRAApplicationModel.EmployeeId,this.KRAApplicationModel.CompanyId);
    });
  }
  
  GetKRAApplication(EmployeeId,CompanyId) 
  { 
    this.KRAApplications=[];
    // Begning of the permission portion
    this.IsDataIsInViewState=false;
    // End of the permision portion
    this.KRAApplicationModel.IsActive=false;
    let t = localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.KRAService.GetKRAApplicationBYEmployeeId( t,EmployeeId,CompanyId).then(x => 
    {
      this.Totalwts=0;
      this.RefId = x;
      if(this.RefId.length > 0)
      {
        this.KRAApplications=[];
      }
      Object.keys(this.RefId).forEach( key => 
      {
        // tslint:disable-next-line:no-unused-expression
        this.RefId[key];
        let KRAApplicationtemp = new KRAApplicationModel();
        KRAApplicationtemp = this.RefId[key];
        if(KRAApplicationtemp.CurrentDate >= KRAApplicationtemp.StartApplicationDate && KRAApplicationtemp.CurrentDate <= KRAApplicationtemp.EndApplicationDate)
        {
          this.KRAApplicationModel.FinalSubmit=KRAApplicationtemp.FinalSubmit;
          this.KRAApplicationModel.MasterRefId=KRAApplicationtemp.MasterRefId;
          this.KRAApplicationModel.SessionId=KRAApplicationtemp.SessionId;
          this.KRAApplicationModel.FinYear=KRAApplicationtemp.FinYear;
          this.Totalwts=this.Totalwts + KRAApplicationtemp.Weighted;
          this.TotalRating=  Number(this.TotalRating) + (Number(KRAApplicationtemp.SelfRating/5) * (KRAApplicationtemp.Weighted));
          if(KRAApplicationtemp.SelfRating==0)
          {
            KRAApplicationtemp.SelfRating=null;
          }
          this.KRAApplications.push(KRAApplicationtemp);
        }
      });
      this.KRAApplicationModel.TotalWateges=this.Totalwts;
      this.KRAApplicationModel.FinalSelfRating=Math.round(this.TotalRating);
    });
  }

  SaveKRAApplication() :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t; 
    this.KRAService.DeActiveKRAApplicationlist(t ,this.KRAApplicationModel.MasterRefId).subscribe(res=>
    {
      if(this.KRAApplicationModel.MasterRefId > 0)
      {
        let t =  localStorage.getItem('userToken');
        t = 'Bearer' + t;
        this.KRAApplicationModel.FinalSubmit=false;
        this.KRAService.UpdateKRAApplicationMaster(t,this.KRAApplicationModel).subscribe(res=>
        {
          this.MasterRefId=res;
          let t = localStorage.getItem('userToken');
          t = 'Bearer' + t;    
          var j=0;
          var l=this.KRAApplications.length;
          this.KRAApplications.forEach(item => 
          {
            j=j+1;
            item.MasterRefId=this.MasterRefId;
            if(item.RefId==null)
            {
              item.RefId=0;
            }
            if(item.RefId > 0)
            {
              this.KRAService.UpdateKRAApplication(t ,item).subscribe(res=>
              {
                this.RefId=res;        
                if(this.RefId>0)
                {
                  localStorage.setItem('SuccessfullMessage', "Save Successfully");
                  this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                }
              });                  
            }                             
            else
            {
              this.KRAService.AddKRAApplication(t ,item).subscribe(res=>
              {
                this.RefId=res;         
                if(this.RefId>0)
                {
                  localStorage.setItem('SuccessfullMessage', "Save Successfully");
                  this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                }
              }); 
            }
          });
        });
      }
      else
      {
        let t =  localStorage.getItem('userToken');
        t = 'Bearer' + t;
        this.KRAApplicationModel.FinalSubmit=false;
        this.KRAService.AddKRAApplicationMaster(t,this.KRAApplicationModel).subscribe(res=>
        {
          this.MasterRefId=res;
          let t = localStorage.getItem('userToken');
          t = 'Bearer' + t;    
          var j=0;
          var l=this.KRAApplications.length;
          this.KRAApplications.forEach(item => 
          {
            j=j+1;
            item.MasterRefId=this.MasterRefId;
            if(item.RefId==null)
            {
              item.RefId=0;
            }
            if(item.RefId > 0)
            {
              this.KRAService.UpdateKRAApplication(t ,item).subscribe(res=>
              {
                this.RefId=res;        
                if(this.RefId>0)
                {
                  localStorage.setItem('SuccessfullMessage', "Save Successfully");
                  this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                }
              });                  
            }                             
            else
            {
              this.KRAService.AddKRAApplication(t ,item).subscribe(res=>
              {
                this.RefId=res;         
                if(this.RefId>0)
                {
                  localStorage.setItem('SuccessfullMessage', "Save Successfully");
                  this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                }
              }); 
            }
          });
        });
      }
    });  
  }

  FinalSubmitKRAApplication()
  {
    this._confirmation.create('Confirm to Final Submit', 'Press Yes to Final Submit', this.settings)
    .subscribe((ans: ResolveEmit) => 
    {
      if (ans.resolved == true) 
      {
        this.DisableSave=false;
        let t =  localStorage.getItem('userToken');
        t = 'Bearer' + t; 
        this.KRAService.DeActiveKRAApplicationlist(t ,this.KRAApplicationModel.MasterRefId).subscribe(res=>
        {
          if(this.KRAApplicationModel.MasterRefId > 0)
          {
            let t =  localStorage.getItem('userToken');
            t = 'Bearer' + t;
            this.KRAApplicationModel.FinalSubmit=true;
            this.KRAService.UpdateKRAApplicationMaster(t,this.KRAApplicationModel).subscribe(res=>
            {
              this.MasterRefId=res;
              let t = localStorage.getItem('userToken');
              t = 'Bearer' + t;    
              var j=0;
              var l=this.KRAApplications.length;
              this.KRAApplications.forEach(item => 
              {
                j=j+1;
                item.MasterRefId=this.MasterRefId;
                if(item.RefId==null)
                {
                  item.RefId=0;
                }
                if(item.RefId > 0)
                {
                  this.KRAService.UpdateKRAApplication(t ,item).subscribe(res=>
                  {
                    this.RefId=res;        
                    if(this.RefId>0)
                    {
                      localStorage.setItem('SuccessfullMessage', "Save Successfully");
                      this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                    }
                  });                  
                }                             
                else
                {
                  this.KRAService.AddKRAApplication(t ,item).subscribe(res=>
                  {
                    this.RefId=res;         
                    if(this.RefId>0)
                    {
                      localStorage.setItem('SuccessfullMessage', "Save Successfully");
                      this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                    }
                  }); 
                }
              });
            });
          }
          else
          {
            let t =  localStorage.getItem('userToken');
            t = 'Bearer' + t;
            this.KRAApplicationModel.FinalSubmit=true;
            this.KRAService.AddKRAApplicationMaster(t,this.KRAApplicationModel).subscribe(res=>
            {
              this.MasterRefId=res;
              let t = localStorage.getItem('userToken');
              t = 'Bearer' + t;    
              var j=0;
              var l=this.KRAApplications.length;
              this.KRAApplications.forEach(item => 
              {
                j=j+1;
                item.MasterRefId=this.MasterRefId;
                if(item.RefId==null)
                {
                  item.RefId=0;
                }
                if(item.RefId > 0)
                {
                  this.KRAService.UpdateKRAApplication(t ,item).subscribe(res=>
                  {
                    this.RefId=res;        
                    if(this.RefId>0)
                    {
                      localStorage.setItem('SuccessfullMessage', "Save Successfully");
                      this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                    }
                  });                  
                }                             
                else
                {
                  this.KRAService.AddKRAApplication(t ,item).subscribe(res=>
                  {
                    this.RefId=res;         
                    if(this.RefId>0)
                    {
                      localStorage.setItem('SuccessfullMessage', "Save Successfully");
                      this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));   
                    }
                  }); 
                }
              });
            });
          }
        }); 
      }
    }) 
  }

  RefreshPage()
  {
    this.rout.navigateByUrl('/Appraisal/KRAApplication', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Appraisal/AllEmployeeKRAApplication"]));
  }

  onItemSelect(item:any)
  {
    let empid= item['id'];
    this.KRAApplicationModel.EmployeeId=empid; 
    if(this.KRAApplicationModel.EmployeeId>0)
    {
      this.FormViewState=true;
      this.GetEmployeeDetails(this.KRAApplicationModel.EmployeeId);
      //this.GetKRAApplication(this.KRAApplicationModel.EmployeeId);
    }     
  }
  OnItemDeSelect(item:any){ }
  onSelectAll(items: any){ }
  onDeSelectAll(items: any){ }

  RatingChanged()
  {
    this.TotalRating=0;
    var j=0;
    var l=this.KRAApplications.length;
    this.KRAApplications.forEach(item => 
    {
      j=j+1;
      if(item.SelfRating > 0)
      { 
        this.TotalRating=  Number(this.TotalRating) + (Number(item.SelfRating/5) * (item.Weighted));
      }
      this.KRAApplicationModel.FinalSelfRating=Math.round(this.TotalRating);
    });
  }
}